/**
 * This file has the global definitions for membership types and roles. *
 */

/**
 * Membership type definition
 * name - The name of the membership type.
 * numberOfRemovals - The number of removals allowed.
 * permissionRank - The permission rank of the membership type. Lower the number, higher the permission.
 */
const membershipTypes = {
  free: {
    name: "free",
    numberOfRemovals: 0,
    permissionRank: 6,
    enabled: false,
  },
  trial: {
    name: "trial",
    numberOfRemovals: 10,
    permissionRank: 5,
    enabled: false,
  },
  amazon: {
    name: "amazon",
    numberOfRemovals: 10,
    permissionRank: 4,
    enabled: true,
  },
  standard: {
    name: "standard",
    numberOfRemovals: 30,
    permissionRank: 3,
    enabled: true,
  },
  premium: {
    name: "premium",
    numberOfRemovals: 100,
    permissionRank: 2,
    enabled: true,
  },
  enterprise: {
    name: "enterprise",
    numberOfRemovals: 1000,
    permissionRank: 1,
    enabled: false,
  },
};

/**
 * Role definition
 * name - The name of the membership type.
 * permissionRank - The permission rank of the membership type. Lower the number, higher the permission.
 */
const roles = {
  ADMIN: {
    name: "admin",
    permissionRank: 1,
  },
  TENANT: {
    name: "tenant",
    permissionRank: 2,
  },
};

const everyone = 100;

export { membershipTypes, roles, everyone };
